import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	id: "list-icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.26172 8.86373C5.26172 7.99191 5.96847 7.28516 6.84029 7.28516H27.1593C28.0312 7.28516 28.7379 7.99191 28.7379 8.86373V9.75421C28.7379 10.626 28.0312 11.3328 27.1593 11.3328H6.84029C5.96847 11.3328 5.26172 10.626 5.26172 9.7542V8.86373Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.26172 16.5542C5.26172 15.6824 5.96847 14.9757 6.84029 14.9757H27.1593C28.0312 14.9757 28.7379 15.6824 28.7379 16.5542V17.4447C28.7379 18.3165 28.0312 19.0233 27.1593 19.0233H6.84029C5.96847 19.0233 5.26172 18.3165 5.26172 17.4447V16.5542Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.26172 24.2447C5.26172 23.3728 5.96847 22.6661 6.84029 22.6661H21.4927C22.3645 22.6661 23.0712 23.3728 23.0712 24.2447V25.1351C23.0712 26.007 22.3645 26.7137 21.4927 26.7137H6.84029C5.96847 26.7137 5.26172 26.007 5.26172 25.1351V24.2447Z",
			fill: "#C4D7FD"
		})
	]
});
export default SvgIcList;
